import type { FrontendWidget } from '../types';
import type { UspRowConfig, UspRowResolved } from './types';
import { UspRowComponent } from './UspRowComponent';

export const uspRowWidget: FrontendWidget<UspRowConfig, UspRowResolved> = {
  componentType: 'widgets.usp-row',
  displayName: 'USP Row',
  ComponentA: UspRowComponent,
  resolveSync: (config) => config,
};
